<template>
<div>
</div>
</template>
<script>
export default {
  data() {
    return {
      instance: null,
    }
  },
  created() {
    let that=this;
    const imageList = (this.$route.query||{}).imageList || [];
    const startPosition = (this.$route.query||{}).index || 0;
    that.instance = that.$ImagePreview({ images: imageList, startPosition: startPosition, showIndex: true, closeOnPopstate: true, onClose() {
      // that.instance = that.$ImagePreview({ images: imageList, startPosition: startPosition, showIndex: true, onClose() {
    that.goBack();
  }});
  },
  methods:{
    goBack(){
      this.$router.back();
    }
  }
}
</script>